import { Box, makeStyles, Paper, Tab, Tabs, Typography, Grid } from '@material-ui/core';
import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export const QueryPreviewPanel = ({ preview, isBigTitleUsed }) => {
    const regions = Object.entries(preview.Regions).map(([name, items]) => ({ name, items }));
    return (
        <Paper elevation={1}>
            <Grid container direction="column" style={{ padding: '20px' }}>
                <Grid item container justifyContent="center" direction="row" style={{ paddingTop: '12px', paddingBottom: '32px' }}>
                    <Grid item>
                        <Typography variant={isBigTitleUsed ? 'h4' : 'h5'} style={{ fontWeight: 500 }}>
                            {preview.Name}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item container justifyContent="center" direction="row" style={{ paddingBottom: '32px' }}>
                    <div style={{ width: 'inherit', height: '3px', background: 'linear-gradient(to right, #3fc66b, #8dd7f7 100%)' }} />
                </Grid>
                <Grid item container direction="column">
                    {regions.map((r, i) => (
                        <Grid item key={i}>
                            <ExpansionPanel elevation={0}>
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                    <Typography variant="button" style={{ fontWeight: '500' }}>
                                        {r.name}
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Typography variant="caption">{r.items.join(', ')}</Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Paper>
    );
};

const QueryPreview = ({ preview, classes }) => {
    const regions = Object.entries(preview.Regions).map(([name, items]) => ({ name, items }));
    const [activeTab, setActiveTab] = React.useState(regions[0].name);

    return (
        <>
            <Box display="flex">
                <Typography className={classes.heading + ' inline'} variant="caption">
                    Alue
                </Typography>
                <Tabs value={activeTab} onChange={(e, newVal) => setActiveTab(newVal)}>
                    {regions.map((r) => (
                        <Tab key={r.name} value={r.name} label={r.name} className={classes.tab} />
                    ))}
                </Tabs>
            </Box>
            {regions.map((r) => {
                const visible = activeTab === r.name;
                if (visible) {
                    return (
                        <Box key={r.name} className={classes.previewItemsContainer}>
                            {r.items.map((i) => (
                                <Typography variant="body1" key={i} className={classes.previewItem}>
                                    {i}
                                </Typography>
                            ))}
                        </Box>
                    );
                } else return undefined;
            })}
        </>
    );
};
QueryPreview.displayName = 'QueryPreview';
// eslint-disable-next-line
const QueryPreviews = ({ configuration }) => {
    const classes = useStyles();
    const previews = configuration.Previews;
    const [activeTab, setActiveTab] = React.useState(previews[0].Name);
    return (
        <Paper>
            <Typography className={classes.heading} variant="h4">
                Raporttien sisällöt
            </Typography>
            <Box display="flex">
                <Typography className={classes.heading + ' inline'} variant="caption">
                    Raporttilaji
                </Typography>
                <Tabs value={activeTab} onChange={(e, newVal) => setActiveTab(newVal)}>
                    {previews.map((p) => (
                        <Tab key={p.Name} value={p.Name} label={p.Name} className={classes.tab} />
                    ))}
                </Tabs>
            </Box>
            {previews.map((p) => {
                const visible = activeTab === p.Name;
                if (visible) {
                    return <QueryPreview key={p.Name} preview={p} classes={classes} />;
                } else return undefined;
            })}
        </Paper>
    );
};

const useStyles = makeStyles((theme) => ({
    heading: {
        marginLeft: theme.spacing(2),
        paddingTop: theme.spacing(2),
        '&.inline': {
            marginTop: 'auto',
            marginRight: theme.spacing(2),
            width: 70,
            textAlign: 'center',
            paddingBottom: theme.spacing(1)
        }
    },
    previewItem: {
        padding: theme.spacing(1, 2),
        marginRight: theme.spacing(2),
        fontSize: 16
    },
    previewItemsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        height: 450,
        placeContent: 'flex-start',
        padding: theme.spacing(2, 1, 1, 1),
        overflow: 'auto'
    }
}));
